const constants = {
  RoleIDs: {
    accountOwner: 'c3c29b52-41d6-45ec-8064-2c558d1a5b2f',
    alertPlusAdmin: 'bffef2c0-001a-442d-b032-e35ea45a8bdb', // Alert Plus Administrator
    officer: 'd4644451-03d1-4ffb-a6fe-5bc48220d539', // Officer
    teacher: 'e5c5013d-04ba-4727-9a15-16508e6217af', // Teacher (updated to current ID)
    editMessageManager: 'eb438a07-8e36-40a8-98b5-c24e85b482a9', // Message Manager Administrator
    messageManagerFrontDeskView: '8e40fe94-e3ec-4f8c-8275-3d83741427ed', // Front Desk Personnel
    orchestrateAdmin: '6e61c47e-7e58-426e-815c-70701b9473cc', // Orchestrate Administrator
    signageAdmin: '038e43fa-552f-42db-b3ba-db176b6e53ee', // Signage Administrator
    signageOwner: '76047cb2-bad6-4562-a2ca-11a7ace34fe7', // Signage Owner
    signageTeacher: 'f7e3561d-5b76-4f84-8d82-1e31e0e8682c', // Signage Teacher
    cmsAdmin: 'a897f327-94b5-4cb6-b60c-bf43970b9e17', // CMS Administrator
    licenseManager: '49f3f591-f440-4964-91aa-f6681ef3dc0b', // Manage licenses
    userAdmin: '2d3308e8-5c0b-4413-9957-1e8503dd3e21', // User Administrator
    warrantyViewer: 'd91cfd7e-2952-4c35-9ba0-a0fd7f644472', // Warranty Viewer
    support: '655f280f-dabc-40cb-8d45-8f9322fd97d4', // Support (keeping existing)
  },
  soracoProductIDs: {
    38: {
      name: 'Alert Plus',
      id: 'alerts-plus',
    },
  },
  permissionIds: {
    aPlusOfficerApp: '43b90cab-e566-4c92-91ec-4174a2a5cd6e',
    aPlusTeacherApp: '255cffa0-ab88-4168-880e-6d60df62e4b3',
    ccServerEdit: 'c3344f95-06ee-46f9-ac42-28a658cd6a4d',
    cmsEdit: 'a1826c14-18bb-4f2f-bdec-2c9bac8ff7a3',
    userEdit: 'e5501406-af8c-4ccb-91e3-fc37b206b1be',
    aPlusEdit: '12e1f72c-420e-4298-b441-3859ce4fb65b',
    licensesEdit: '756801b1-e505-49a0-8eb8-88a66a13bd89',
    hwWarrantyEdit: 'f420ec4c-0ebc-4ad9-8e89-77075bbae9d2',
    hwWarrantyRead: 'dcc0473d-e1cb-4ed7-88a3-9eaa83a68621',
    support: 'b78572a0-d7b5-4b1c-bb38-44c0b1310ef4',
    msgManagerEdit: '5837988d-cfff-41cd-aaab-6ad1e2c38e59',
    msgManagerFrontDeskView: '2605f8b1-dcd6-4e84-92b6-107418f0151e',
    signagePlusEdit: 'b11eefbf-065a-470c-8204-e6ecb1aefb3b',
    signagePlusOwner: '3a8f7bd0-3427-4d18-9291-30041b0d28de',
    signagePlusTeacher: 'd6ac5874-007b-4dec-ade0-942f5ab6dfe3',
  },
  featureIds: {
    aPlus: '1f0f6ccd-146d-44df-a379-54eccbeb473e',
    licenseManagement: 'fccfc805-26d3-4bd9-8374-be419935957d',
    orchestrate: '587e8e6a-ee08-4c63-b812-a4f60204e0b1',
    hwWarranty: '672597bc-8086-4457-b036-690c985ef829',
    msgManager: 'f07b57b8-a1a0-470a-8dc8-6811e649eab2',
    signagePlus: '9aeaf825-0152-49b0-aa38-79ae9998ef6e',
  },
  userStatus: {
    unverified: 0,
    verified: 1,
  },

  globalPolicies: {
    password: 'd53bcda0-a108-4b18-b066-1b04bdfbe200',
    twoFactorAuth: '8eef3696-e258-40e7-a611-bafa2bb42c71',
    changePasswordOnFirstLogin: '6c364af4-fdef-4a73-ba19-33e897fc05e9',
  },

  sendGridTemplates: {
    emailVerification: 'd-2e6f5ae8182e4dfcb9a3886700757d5',
    passwordReset: 'd-faf69114eb96438b9a3c4702419f98d5',
  },

  webSocketIDs: {
    unknownMessage: 1000,
    getLicenses: 1001,
    updateLicense: 1002,
    useLicense: 1003,
    deAssignLicense: 1004,
    getSitesCMS: 2000,
    modifySiteCMS: 2001,
    getTemplatesCMS: 2002,
    modifyTemplatesCMS: 2003,
    sendAlertCMS: 2004,
    alertStatusCMS: 2005,
    getTemplateEditURL: 2006,
    getReceivers: 2007,
    downloadFile: 2008,
    getAlertTemplatesMobile: 3000,
    sendAlert: 3001,
    alertStatus: 3002,
  },

  sessionTypes: {
    CMS: 'CMS',
    CCServer: 'CC-Server',
    AlertsPlusMobile: 'AlertsPlusMobile',
    WebClient: 'WebClient',
  },

  LicenseIds: {
    alertPlus: '6f0a230e-eb68-4c01-9935-a82e21589803',
  },

  cmsConstants: {
    parentSiteId: '00000000-0000-0000-0000-000000000000',
    cmsPingInterval: 1000*20,
  },

  referralMap: {
    1: {
      name: 'Orchestrate',
      path: '/orchestrate'
    }
  },

  links: {
    licenseEULA: "https://www.screenbeam.com/terms",
  },

  supportAccount: 'c3c29b52-41d6-45ec-8064-2c558d1a5b2a',
  pageType: {
    Users: "Users",
    AccountManagement: "Account Management",
    AlertPlus: "Alert Plus",
    ManageAlerts: "Manage Alerts",
    Log: "Log",
    Templates: "Templates",
    AlertPlusTemplates:"Create Alert Templates",
    AlertPlusUsers:"Alert Plus Users",
    CMSManagement:"CMS Management",
    Companies: "Companies",
    Licenses: "Licenses",
    UserRoles: "User Roles",
    HardwareWarranty: "Hardware Warranty",
    ApiKey: 'API Key',
    SiteMapping: 'Site Mapping',
    MessageStatus: "Status",
    Receivers: "Receivers",
    MessageManager: "Message Manager",
    LatestScheduledMessages: "Latest Scheduled Messages",
    MessageLogs: "Logs",
    MessageHistory: "History",
    GroupManagement: "Group Management",
    ReceiversAndSignageControl: "Receivers and Signage Control",
    MediaLibrary: "Media Library",
    Drafts: "DRAFTS",
    SignageHistory: "Signage History",
  },

  CMSESSOPages:{
    Connect: "connect",
    SignIn:"signIn",
    Success:"success",
    TermsAndConditions:"terms",
    SignUp:"signUp",
    VerifyAccount:"verifyAccount",
    ForgotPassword:"forgotPassword",
    ResendVerificationEmail:"resendVerificationEmail",
  },

  BlockEmailDomainsList:{
    EmailDomains:[
      "gmail.com",
      "yahoo.com",
      "hotmail.com",
      "aol.com",
      "outlook.com",
      "comcast.net",
      "icloud.com",
      "msn.com",
      "hotmail.co.uk",
      "sbcglobal.net",
      "live.com",
      "yahoo.co.in",
      "me.com",
      "att.net",
      "mail.ru",
      "bellsouth.net",
      "rediffmail.com",
      "cox.net",
      "yahoo.co.uk",
      "verizon.net",
      "ymail.com",
      "hotmail.it",
      "kw.com",
      "yahoo.com.tw",
      "mac.com",
      "live.se",
      "live.nl",
      "yahoo.com.br",
      "googlemail.com",
      "libero.it",
      "web.de",
      "allstate.com",
      "btinternet.com",
      "online.no",
      "yahoo.com.au",
      "live.dk",
      "earthlink.net",
      "yahoo.fr",
      "yahoo.it",
      "gmx.de",
      "hotmail.fr",
      "shawinc.com",
      "yahoo.de",
      "moe.edu.sg",
      "163.com",
      "naver.com",
      "bigpond.com",
      "statefarm.com",
      "remax.net",
      "rocketmail.com",
    ],
  },

  rolesIdsSort:[
    'c3c29b52-41d6-45ec-8064-2c558d1a5b2f', //Account Owner
    'bffef2c0-001a-442d-b032-e35ea45a8bdb', //Alert Plus Administrator
    'd4644451-03d1-4ffb-a6fe-5bc48220d539', //Officer
    'e5c5013d-04ba-4727-9a15-16508e6217af', //Teacher
    'eb438a07-8e36-40a8-98b5-c24e85b482a9', //Message Manager Administrator
    '8e40fe94-e3ec-4f8c-8275-3d83741427ed', //Front Desk Personnel
    '6e61c47e-7e58-426e-815c-70701b9473cc', //Orchestrate Administrator
    '038e43fa-552f-42db-b3ba-db176b6e53ee', //Signage Administrator
    '76047cb2-bad6-4562-a2ca-11a7ace34fe7', //Signage Owner
    'f7e3561d-5b76-4f84-8d82-1e31e0e8682c', //Signage Teacher
    'a897f327-94b5-4cb6-b60c-bf43970b9e17', //CMS Administrator
    '49f3f591-f440-4964-91aa-f6681ef3dc0b', //Manage licenses
    '2d3308e8-5c0b-4413-9957-1e8503dd3e21', //User Administrator
    'd91cfd7e-2952-4c35-9ba0-a0fd7f644472', //Warranty Viewer
  ],
  timezome: {
    "Pacific/Pago_Pago": "(UTC-11:00) American Samoa",
    "Pacific/Honolulu": "(UTC-10:00) Honolulu",
    "Pacific/Marquesas": "(UTC-09:30) French Polynesia",
    "America/Anchorage": "(UTC-09:00) Anchorage",
    "America/Los_Angeles": "(UTC-08:00) Pacific Time",
    "America/Denver": "(UTC-07:00) Mountain Time",
    "US/Arizona": "(UTC-07:00) Arizona",
    "America/Chicago": "(UTC-06:00) Central Time",
    "America/Mexico_City": "(UTC-06:00) Mexico Time",
    "America/New_York": "(UTC-05:00) Eastern Time",
    "America/Caracas": "(UTC-04:00) Caracas",
    "America/Halifax": "(UTC-04:00) Atlantic Time",
    "America/St_Johns": "(UTC-03:30) Newfoundland",
    "America/Argentina/Buenos_Aires": "(UTC-03:00) Buenos Aires",
    "Atlantic/South_Georgia": "(UTC-02:00) South Sandwish Island",
    "Atlantic/Azores": "(UTC-01:00) Azores Islands",
    "UTC": "(UTC+00:00) Universal Time",
    "Europe/London": "(UTC+00:00) Greenwich",
    "Europe/Amsterdam": "(UTC+01:00) Amsterdam",
    "Africa/Cairo": "(UTC+02:00) Cairo",
    "Europe/Moscow": "(UTC+03:00) Moscow",
    "Asia/Tehran": "(UTC+03:30) Tehran",
    "Asia/Dubai": "(UTC+04:00) Dubai",
    "Asia/Kabul": "(UTC+04:30) Kabul",
    "Asia/Karachi": "(UTC+05:00) Islamabad",
    "Asia/Kolkata": "(UTC+05:30) New Delhi",
    "Asia/Kathmandu": "(UTC+05:45) Katmandu",
    "Asia/Dhaka": "(UTC+06:00) Dhaka",
    "Asia/Rangoon": "(UTC+06:30) Rangoon",
    "Asia/Bangkok": "(UTC+07:00) Bangkok",
    "Asia/Shanghai": "(UTC+08:00) Beijing",
    "Asia/Tokyo": "(UTC+09:00) Tokyo",
    "Australia/Adelaide": "(UTC+09:30) Adelaide",
    "Australia/Darwin": "(UTC+09:30) Darwin",
    "Australia/Sydney": "(UTC+10:00) Sydney",
    "Australia/Brisbane": "(UTC+10:00) Brisbane",
    "Pacific/Guadalcanal": "(UTC+11:00) Solomon Island",
    "Pacific/Auckland": "(UTC+12:00) Auckland",
    "Pacific/Apia": "(UTC+13:00) Samoa",
    "Pacific/Kiritimati": "(UTC+14:00) Kiritimati Island"
  },
  ARCGIS_API: {
    suggest: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest',
    findAddressCandidates: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates',
  },
  SIGNAGE_MEDIA:{
    MEDIA_CATEGORY: {
      MEDIA: 'media',
      LINK: 'link',
      WIDGET: 'widget',
      CANVA: 'canva',
    },
    MEDIA_SUB_CATEGORY: {
      FOLDER: 'folder',
      FILE: 'file',
      LINK: 'link',
      CODE: 'code',
      CANVA: 'canva',
      WEATHER: 'weather',
      CLOCK: 'clock',
      CALENDAR: 'calendar',
    },
    MEDIA_TYPE: {
      TYPE_MP4: 'mp4',
      TYPE_PDF: 'pdf',
      TYPE_PPT: 'pptx',
      TYPE_IMAGE_JPG: 'jpg',
      TYPE_IMAGE_JPEG: 'jpeg',
      TYPE_IMAGE_PNG: 'png',
      TYPE_IMAGE_GIF: 'gif',
      TYPE_WEATHER: 'weather',
      TYPE_CLOCK: 'clock',
      TYPE_CALENDAR: 'calendar',
      TYPE_IMAGES: 'images',
      TYPE_YOUTUBE: 'youtube',
      TYPE_VIMEO: 'vimeo',
      TYPE_ANALOG: 'Analog',
      TYPE_DIGITAL: 'Digital',
      TYPE_LINK: 'link',
    },
    CREATE_SIGNAGE: {
      DAILY: 'daily',
      RECURRING: 'recurring',
      WIDGET1: 'widget1',
      WIDGET2: 'widget2',
      NORMAL: 'normal',
      PLAYLIST: 'playlist',
      TICKER: 'ticker',
      DRAFT: 'draft'
    }
  },
};

module.exports = constants;
